import script from "./CategoriesShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriesShow.vue?vue&type=script&setup=true&lang=ts"

import "./CategoriesShow.vue?vue&type=style&index=0&id=ee94d4c8&lang=scss"

const __exports__ = script;

export default __exports__